import http from "../../axios-config/g-http-metodos";

function GetReclamacaoByFiltro(filtros){
    const{res, erro, requisicao} = http.postArray('/reclamacao/GetReclamacaoByFiltro', filtros)
    return{ ReclamacaoArray: res, erro , requisicao}
}

function GetDetalhesReclamacao(Id) {
    const{res, erro, requisicao} = http.getArray(`/ReclamacaoTecnica/GetDetalhesReclamacaoTecnica/${Id}`)
    return{ DetalhesReclamacao: res, erro , requisicao}
}

const ReclamacaoTecnicaController ={
    GetReclamacaoByFiltro,
    GetDetalhesReclamacao
}

export default ReclamacaoTecnicaController